/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sample_TitleInputs */

const cs_builder_sample_title = /** @type {(inputs: Builder_Sample_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Živá ukázková data`)
};

const en_builder_sample_title = /** @type {(inputs: Builder_Sample_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live sample data`)
};

/**
* | output |
* | --- |
* | "Live sample data" |
*
* @param {Builder_Sample_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sample_title = /** @type {((inputs?: Builder_Sample_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sample_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sample_title(inputs)
	return cs_builder_sample_title(inputs)
});